import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun, Plus } from "lucide-react";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

const Header = ({ darkMode, setDarkMode, currentPage = "home" }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <header className="w-full bg-transparent text-black dark:text-white">
      <div className="mx-auto grid grid-cols-[1fr_auto_1fr] items-center py-2 px-5 max-w-8xl">
        {/* Left Column: Logo */}
        <div className="flex items-center justify-start">
          <div className="flex items-center">
            <div 
              onClick={() => window.location.href = '/'} 
              className="cursor-pointer"
            >
              <h1 
                className="text-lg font-extrabold hover:opacity-80 transition-opacity"
                style={{ color: darkMode ? '#ffffff' : '#000000' }}
              >
                CoachAI
              </h1>
            </div>
            <Button 
              variant="ghost" 
              size="icon" 
              className={`ml-4 rounded-full h-6 flex items-center justify-center hover:opacity-80 transition-all duration-300 ease-in-out cursor-pointer overflow-hidden relative ${
                isHovered ? 'w-32 px-3' : 'w-6'
              }`}
              style={{ backgroundColor: darkMode ? 'white' : '#161D26' }}
              onClick={() => window.location.reload()}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Plus 
                className={`h-4 w-4 absolute transition-opacity duration-300 ${
                  isHovered ? 'opacity-0' : 'opacity-100'
                }`}
                style={{ color: darkMode ? '#161D26' : 'white' }} 
                strokeWidth={3} 
              />
              <span 
                className={`text-xs font-medium whitespace-nowrap transition-opacity duration-300 ${
                  isHovered ? 'opacity-100' : 'opacity-0 absolute'
                }`}
                style={{ color: darkMode ? '#161D26' : 'white' }}
              >
                Start Over
              </span>
            </Button>
          </div>
        </div>
        {/* Center Column: Nav Links */}
        <nav className="flex justify-center space-x-12">
          <Link
            to="/"
            className={cn(
              "text-base 3xl:text-lg font-Regular hover:text-orange-500 dark:hover:text-blue-400 transition-colors",
              currentPage === "home"
                ? "text-orange-500 dark:text-blue-400 font-bold"
                : ""
            )}
            style={{
              color: currentPage === "home" 
                ? (darkMode ? "#60A5FA" : "#F97316") 
                : (darkMode ? "#ffffff" : "#000000")
            }}
          >
            Home
          </Link>
          <Link
            to="/scenario"
            className={cn(
              "text-base 3xl:text-lg font-regular hover:text-orange-500 dark:hover:text-blue-400 transition-colors",
              currentPage === "scenario"
                ? "text-orange-500 dark:text-blue-400 font-bold"
                : ""
            )}
            style={{
              color: currentPage === "scenario" 
                ? (darkMode ? "#60A5FA" : "#F97316") 
                : (darkMode ? "#ffffff" : "#000000")
            }}
          >
            Scenario Practice
          </Link>
        </nav>
        {/* Right Column: Dark Mode Toggle */}
        <div className="flex items-center justify-end">
          <Button
            onClick={() => setDarkMode(!darkMode)}
            variant="ghost"
            className="flex items-center space-x-2 text-black dark:text-white rounded-full"
          >
            {darkMode ? (
              <>
                <Sun className="h-8 w-8 text-white-500 hover:text-blue-500" />
                <span className="text-sm hover:text-blue-500">Light Mode</span>
              </>
            ) : (
              <>
                <Moon className="h-8 w-8 text-black-200" />
                <span className="text-sm hover:text-orange-500">Dark Mode</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
